import type { baiduModelConfig, InputPayloadType } from './types';
import { baiduModelConfigs } from './config';

/**
 * 获取模型配置
 */
export function getbaiduModelConfig(modelId: string): baiduModelConfig {
    const config = baiduModelConfigs[modelId];
    if (!config) {
        throw new Error(`Model ${modelId} not found`);
    }
    return config;
}

/** 渠道是否支持百度 AIGC 素材审核（no-review / 不支持审核时为 false） */
export function shouldReviewBaiduAigcMaterial(modelId: string): boolean {
    const config = baiduModelConfigs[modelId];
    return Boolean(config?.enableAigcMaterialReview);
}

/**
 * 构建输入参数
 */
export async function buildInputPayloadFromConfig(
    modelId: string,
    params: {
        prompt: string;
        imagePrompt?: string[];
        videoUri?: string;
        videoUris?: string[];
        audioUri?: string;
        audioUris?: string[];
        duration: number;
        aspectRatio?: string;
        quality?: string;
        modelUi?: Record<string, any>;
        providerOptions?: Record<string, Record<string, any>>;
    }
): Promise<InputPayloadType> {
    // 获取服务商配置
    const config = getbaiduModelConfig(modelId);
    
    // 构建输入参数
    const result = await config.buildInput(params);

    return result;
}